// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UploadZipDocumentRequestModel from '../../model/upload-zip-document-request-model';
import UploadZipDocumentRequestDTO from '../dto/upload-zip-document-request-dto';
import dtoSchema from '../schemas/upload-zip-document-request-schema';

export default abstract class UploadZipDocumentRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UploadZipDocumentRequestDTO>) {
    super();
    if (data) {
      this.uploadFile = data.uploadFile;
      this.uploadFilename = data.uploadFilename;
      this.entityType = data.entityType;
      this.entityId = data.entityId;
    }
  }
  /**
  * @type {binary}
  */
  uploadFile?: File;
  /**
  */
  uploadFilename?: string;
  /**
  */
  entityType?: string;
  /**
  * @type {int64}
  */
  entityId?: number;

  static toModel(dto: DeepPartial<UploadZipDocumentRequestDTO>): UploadZipDocumentRequestModel;
  static toModel(dto: DeepPartial<UploadZipDocumentRequestDTO> | undefined | null): UploadZipDocumentRequestModel | undefined;
  static toModel(dto: DeepPartial<UploadZipDocumentRequestDTO> | undefined | null): UploadZipDocumentRequestModel | undefined {
    return dto ? new UploadZipDocumentRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UploadZipDocumentRequestModel> | UploadZipDocumentRequestModel): UploadZipDocumentRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      uploadFile: unwrapped.uploadFile,
      uploadFilename: unwrapped.uploadFilename,
      entityType: unwrapped.entityType,
      entityId: unwrapped.entityId,
    } as UploadZipDocumentRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UploadZipDocumentRequestModel, can not map to UploadZipDocumentRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
